import { Animation, PageTransition } from 'ionic-angular';

export class ModalScaleUpEnterTransition extends PageTransition {

    init() {
        super.init();
        const ele: HTMLElement = this.enteringView.pageRef().nativeElement;
        const backdropEle = ele.querySelector('ion-backdrop');
        const backdrop = new Animation(this.plt, backdropEle);
        const wrapper = new Animation(this.plt, ele.querySelector('.modal-wrapper'));

        wrapper.beforeStyles({ 'opacity': 1 });
        wrapper.fromTo('transform', 'scale(0.8)', 'scale(1)');
        wrapper.fromTo('opacity', '0', '1');

        backdrop.fromTo('opacity', 0.01, 0.4);

        this
            .element(this.enteringView.pageRef())
            // .easing('cubic-bezier(0.36,0.66,0.04,1)')
            .easing('ease-out')
            .duration(300)
            .add(backdrop)
            .add(wrapper);
    }

}



// WEBPACK FOOTER //
// ./src/transitions/scale/scale-up-enter.transition.ts